// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.CalculatedFunction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * CalculatedFunction component
 */
import React from 'react';
import { observer } from 'mobx-react';
import { action } from 'mobx';
import FormGroup from 'share/components/controls/Izenda.FormGroup';
import Label from 'share/components/controls/Izenda.Label';
import DropDown from 'share/components/controls/Izenda.DropDown';

@observer
class CalculatedFunction extends React.Component {
  static displayName = 'PropertiesEditorContainer';

  /**
   * Handle change function name event
   * @param {Object} e
   */
  @action
  onChangeFunctionName = (e: Object) => {
    this.props.store.clonedModel.changeFunctionName(e.value);
    this.props.validation.reset();
  };

  render() {
    const { type: popupLabels, store: { clonedModel: model } } = this.props;

    return popupLabels.functionLabel
      ? <FormGroup className="u_paddingRight">
          <Label className="col-md-3 text-left u_paddingLeft">
            {popupLabels.functionLabel}
          </Label>
          <div className="col-md-9 u_noPaddingAll">
            <DropDown
              options={model.functions}
              onChange={this.onChangeFunctionName}
              value={model.functionName}
            />
          </div>
        </FormGroup>
      : null;
  }
}

export default CalculatedFunction;



// WEBPACK FOOTER //
// ./ui/share/components/controls/calculatedField/Izenda.CalculatedFunction.js